
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { TrendingUp } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import { useScanCounter } from '@/hooks/useScanCounter';

const TelemarketingScanCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const scanCount = useScanCounter();

  useEffect(() => {
    // Add a small delay before showing the component with fade effect
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className={`bg-gradient-to-b from-brand-lightBlue to-white/80 py-12 border-y border-gray-100 transition-opacity duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="container">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="bg-white/70 rounded-full p-6 hidden md:flex">
            <TrendingUp size={64} className="text-brand-blue" aria-hidden="true" />
          </div>
          
          <div className="flex-1 space-y-4 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-4 mb-2">
              <TrendingUp size={28} className="text-brand-blue md:hidden" aria-hidden="true" />
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                Is jouw KMO klaar voor meer klanten – zonder extra personeel?
              </h2>
            </div>
            <p className="text-gray-700 text-base md:text-lg">
              Doe de gratis Telemarketing Scan en ontdek in 3 minuten of jouw bedrijf klaar is voor externe afspraakplanning. Geen verplichtingen, wel inzichten.
            </p>
            <div className="pt-2">
              <Progress 
                value={33} 
                className="h-2" 
                ariaLabel="Voortgang telemarketing scans" 
                ariaValueText="33% van de KMO's hebben de scan voltooid" 
              />
              <p className="text-sm text-gray-500 mt-1">Al <span className="font-semibold">{scanCount}</span> KMO's gingen je voor</p>
            </div>
          </div>
          
          <div className="shrink-0">
            <Link to="/telemarketing-scan">
              <Button variant="highlight" size="xl" className="whitespace-nowrap tracking-tight bg-brand-blue hover:bg-brand-darkBlue text-white shadow-md hover:shadow-lg transition-all focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue">
                <TrendingUp size={18} aria-hidden="true" />
                Start de gratis scan
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TelemarketingScanCTA;
